/**
 * La marca dentro de la aplicación: el plato visto desde arriba, lo registrado adentro y el
 * destello del modelo afuera.
 *
 * Es el mismo dibujo que `public/icon.svg`, con dos diferencias que importan.
 *
 * Sin campo de color. Acá la marca vive sobre el fondo de la pantalla, y un bloque naranja
 * plantado en medio de una pantalla que ya es de marca sería una mancha, no una firma. El ícono
 * de la aplicación sí lo lleva, porque ahí compite contra el fondo de pantalla de un teléfono.
 *
 * Y los renglones son huecos de verdad, no rectángulos pintados del color del fondo. Un
 * rectángulo pintado obliga a saber sobre qué fondo cae —y en esta aplicación eso cambia con el
 * tema, y en la pantalla de ingreso ni siquiera es plano—. Con `fill-rule="evenodd"` sobre un
 * único trazado, el disco y los renglones se restan entre sí y se ve lo que haya detrás, sea lo
 * que sea.
 */
export function Logo({ size = 28, title }: { size?: number; title?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="currentColor"
      role={title === undefined ? 'presentation' : 'img'}
      aria-hidden={title === undefined}
      aria-label={title}
    >
      {title !== undefined && <title>{title}</title>}
      <path
        fillRule="evenodd"
        d="M80 292a152 152 0 1 0 304 0 152 152 0 1 0-304 0ZM140 250h188v34H140ZM196 316h132v34H196Z"
      />
      <path d="M404 72 421 122 471 139 421 156 404 206 387 156 337 139 387 122Z" />
    </svg>
  );
}
